import { c as _c } from "react/compiler-runtime";
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { TopControlTest } from '@src/components/sco/CardCarousel/Controls/TopControlTest';
import { ArticleCard } from '@src/components/sco/Education/ArticleLanding/ArticleCard';
import { hourSeed, seededShuffle } from '@src/lib/seededShuffle';
type ArticleListFeaturedProps = {
  articles: any[];
  typeTitle?: string;
  typeSlug?: string;
  carouselTitle?: string;
  carouselProps?: CardCarouselProps;
};
export const ArticleListFeatured = props => {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.articles || $[1] !== props.carouselProps || $[2] !== props.carouselTitle || $[3] !== props.typeSlug) {
    const shuffledArray = seededShuffle(props.articles, hourSeed());
    let t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [1, 1, 2, 3, 3, 4];
      t2 = {
        top: TopControlTest,
        bottom: false
      };
      $[5] = t1;
      $[6] = t2;
    } else {
      t1 = $[5];
      t2 = $[6];
    }
    let t3;
    if ($[7] !== props.typeSlug) {
      t3 = article => <ArticleCard key={article.id} image={article.featuredImage?.url} subject={article.subjectNames.join(" & ")} subjectLogo={article.subjectLogos[0]?.url} summary={article.seoDescription} title={article.title} url={`/${props.typeSlug || "articles"}/${article.slug}`} />;
      $[7] = props.typeSlug;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t0 = <CardCarousel fade={false} spacing={8} title={props.carouselTitle} visibleCards={t1} controls={t2} {...props.carouselProps}>{shuffledArray.slice(0, 8).map(t3)}</CardCarousel>;
    $[0] = props.articles;
    $[1] = props.carouselProps;
    $[2] = props.carouselTitle;
    $[3] = props.typeSlug;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};